import { Card, Input } from "reactstrap";
import AllDropDowns from "../dropdown/AllDropdowns";
import moment from "moment";
import ReturnDropdown from "../dropdown/ReturnDropdown";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";
import { returnStatusShip } from "../../data";
import { FiCopy } from "react-icons/fi";
import toast from "react-hot-toast";

const SaleOrderInformations = ({
  state,
  orderNumber,
  setOrderNumber,
  shipBy,
  setShipBy,
  orderData,
  returnOrder,
  returnOrders,
  customer_acc,
  setCustomerAcc,
}) => {
  const { pathname } = useLocation();
  const route = pathname.split("/");
  const { all_customers } = useSelector((state) => state.orders);
  const getCustomerId = (customer_id) => {
    let res = all_customers?.find((i) => i?.id === customer_id);
    return res;
  };
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const { user } = useSelector((state) => state.auth);
  return (
    <Card className="border-1 h-100  rounded-0 bg-light p-2 my-2 my-lg-0 billingShippingCard">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="primary-color "> Order Info</h5>
        {route.includes("sale-order-details") && returnOrders?.length > 0 && (
          <ReturnDropdown
            dropdownOpen={dropdownOpen}
            toggle={toggle}
            returnOrders={returnOrders}
            orderData={state}
          />
        )}
      </div>
      <div className="fs-16">
        <div className="d-flex justify-content-between">
          <p className="mb-0">{returnOrder ? "Return " : "TM"} Order</p>
          <p
            className="mb-0 primary-color pointer d-flex align-items-center gap-1"
            title="Click to copy"
            onClick={() => {
              navigator.clipboard.writeText(state?.id);
              toast.success("Order number copied!");
            }}
          >
            {state?.id}
            <FiCopy size={14} />
          </p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0">Date</p>
          <p className="mb-0 primary-color">
            {moment(state?.date_created).format("MM/DD/YYYY")}
          </p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0">Customer ID</p>
          <p className="mb-0 primary-color">
            {state?.customer_id ?? getCustomerId(state?.customer_id)?.id}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-0">
          <p className="mb-0 fw-bold">Customer PO No</p>
          <Input
            style={{ width: "60%", height: "30px" }}
            value={orderNumber}
            type={"text"}
            placeholder="Customer Order number"
            onChange={(e) => setOrderNumber(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-between align-items-center mb-0">
          <p className="mb-0 fw-bold">
            Ship By <span className="text-danger">*</span>
          </p>
          <AllDropDowns
            selectedClassName={" w-full"}
            // title={"Ship By"}
            dropDownMenu={returnStatusShip}
            selectedwidth="200px"
            placeholder={"Select Ship By"}
            value={shipBy}
            setValue={(value) => {
              const a = shipBy;
              setShipBy(value);
            }}
            fontSize={"14px"}
          />
        </div>
      </div>



      {route.includes("sale-order-details") && (
        <div className="d-flex align-items-center gap-2 mb-0">
          <p className="mb-0  fw-bold">Cust Ship Acc #</p>
          <Input
            style={{ width: "60%", height: "30px" }}
            value={customer_acc}
            placeholder=" Account Number"
            onChange={(e) => {
              setCustomerAcc(e.target.value);
            }}
          />
        </div>
      )}

    </Card >
  );
};
export default SaleOrderInformations;
